<template>
  <div class="checkTab" style="height:100%">
    <header>
      <el-tooltip effect="dark" content="返回" placement="bottom">
        <button @click="backtrack" style="cursor:pointer" class="returnBtn">
          <i class="el-icon-back"></i>
        </button>
      </el-tooltip>

      <!-- <span> 返回</span> -->
      <div>双语对齐详情</div>
    </header>
    <main>
      <h3>名称：{{rowName}}</h3>
      <div class="topBox">
        <div class="topBox_btn_wrap">
          <el-tooltip class="item" effect="dark" placement="bottom">
            <div slot="content" style="text-align:center">
              快捷键：Ctrl+[
            </div>
            <button @click="getMesBox">添加</button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" placement="bottom">
            <div slot="content" style="text-align:center">
              快捷键：Ctrl+]
            </div>
            <button @click="toggleBox">删除</button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" placement="bottom">
            <div slot="content" style="text-align:center">
              快捷键：Ctrl+G
            </div>
            <button @click="onMerge">合并</button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" placement="bottom">
            <div slot="content" style="text-align:center">
              快捷键：Ctrl+Alt+G
            </div>
            <button @click="onSplit">拆分</button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" placement="bottom">
            <div slot="content" style="text-align:center">
              快捷键：Ctrl+Z
            </div>
            <button @click="onUndo">回退</button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" placement="bottom">
            <div slot="content" style="text-align:center">
              快捷键：Ctrl+Y
            </div>
            <button @click="onRedo">重做</button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" placement="bottom">
            <div slot="content" style="text-align:center">
              快捷键：Ctrl+F
            </div>
            <button @click="seekShow">查找</button>
          </el-tooltip>
        </div>
        <div class="topBox_btn_right">
          <el-tooltip class="item" effect="dark" placement="bottom">
            <div slot="content" style="text-align:center">
              快捷键：Ctrl+M
            </div>
            <el-button @click="countBlankSent">保存到记忆库</el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" placement="bottom">
            <div slot="content" style="text-align:center">
              快捷键：Ctrl+Delete
            </div>
            <el-button @click="allDele">全部删除</el-button>
          </el-tooltip>

        </div>
      </div>
      <template>
        <div style="overflow: auto;height:calc(100% - 120px)">
          <el-table ref="multipleTable" id="multipleTable" :data="tableData"
            :header-cell-style="{background:'#EAEAEA',color:'#  454545',padding:'6.5px 0'}" tooltip-effect="dark"
            style="width:100%" border @selection-change="handleSelectionChange" v-loading="loading" row-key="id"
            :resizable="false" :highlight-current-row="true">
            <el-table-column :resizable="false" type="selection" width="60"></el-table-column>
            <el-table-column :resizable="false" type="index" label="序号" width="80"></el-table-column>
            <el-table-column :resizable="false" prop="sourceSent" :label="sourceSent" width>
              <template slot-scope="scope">
                <div class="edit" contenteditable="true" type="source" :sId="scope.row.id" @focus="changeVerify($event)"
                  @blur="changeUpdate(scope.row,$event.target,0)" @click="getCursortPosition($event,scope.row);"
                  v-html="scope.row.sourceSent" @mouseup="pitchOn"></div>
              </template>
            </el-table-column>
            <el-table-column :resizable="false" prop="targetSent" :label="targetSent" width>
              <template slot-scope="scope">
                <div class="edit" contenteditable="true" type="target" :sId="scope.row.id" @focus="changeVerify($event)"
                  @blur="changeUpdate(scope.row,$event.target,1)" @click="getCursortPosition($event,scope.row);"
                  v-html="scope.row.targetSent" @mouseup="pitchOn"></div>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </template>
      <el-pagination class="page" background layout="total,prev, pager, next" :page-size="20" :total="totalRows"
        prev-text="上一页" next-text="下一页" :current-page.sync="currentPage" @current-change="handleCurrentChange">
      </el-pagination>
    </main>
    <div class="downloadBox" v-show="isShow">
      <h5>
        {{downloadBoxTit}}
        <span @click="getMesShow">
          <img src="../../assets/imgs/message/popup_close_normal.png" alt />
        </span>
      </h5>
      <div class="main" v-show="!isDel ? true :false">
        <div class>
          <p>原文</p>
          <textarea class="txt" v-model="topText"></textarea>
        </div>
        <div class>
          <p>译文</p>
          <textarea class="txt" v-model="botText"></textarea>
        </div>
      </div>
      <div v-show="isDel ? true :false" class="mainText">确认删除选中的{{checkTxt}}条目？</div>
      <div class="but">
        <button class="themeCallBut" @click="call">取消</button>
        <button class="themeGoBut" ref="delEnsureBtn" @click="confirm">确定</button>
      </div>
    </div>
    <div class="hide" v-show="isShow"></div>
    <Seek v-show="isSeekBox" :seekTxt="seekTxt" :seekTxt2="seekTxt2" :seekNum="seekNum" :seekNum2="seekNum2"
      @seekNext="seekNext" @previous="previous" @seekChange="seekChange" @onReplace="onReplace"
      @replaceChange="replaceChange" @onSeekTxt="onSeekTxt" @onSeekTxt2="onSeekTxt2" @onClose="seekShow"></Seek>
  </div>
</template>

<script>
import Sortable from 'sortablejs';
import Seek from './components/seek.vue'
export default {
  name: "alignmentDetails",

  data() {
    return {
      tableData: [],
      multipleSelection: [], // 存储选中的数组
      butClass: "",
      isShow: false,
      downloadBoxTit: "",
      topText: "",
      botText: "",
      isDel: false,
      rowName: "",
      rowId: "",
      checkPageUrl: "",
      checkAddUrl: "",
      checkDelUrl: "",
      totalRows: 0, // 分页数据总数
      loading: true,
      sentCount: "",
      sourceSent: "",
      targetSent: "",
      updateText: "",
      checkTxt: "双语对齐",
      quetyData: {},
      sortable: null,
      isSeekBox: null,
      seekTxt: "",
      seekTxt2: "",
      seekNum: 0,
      seekNum2: 0,
    };
  },
  components: {
    Seek
  },
  watch: {
    isShow: {
      immediate: false,
      handler: function () {
        this.selfShow = this.isShow;
        if (this.isShow) {
          this.$refs.delEnsureBtn.focus();
          document.addEventListener("keyup", this.keyUp);
        } else {
          document.removeEventListener("keyup", this.keyUp);
        }
      }
    }
  },
  created() {
    this.quetyData = this.$route.query
    this.rowName = this.quetyData.batchName;
    // this.rowId = params.rowId;

    this.currentPage = Number(sessionStorage.getItem("myCurrentPage")) || 1;
    this.queryPage(this.currentPage, this.quetyData.groupId);
  },
  mounted() {
    window.addEventListener("keydown", this.shortcutKey, false);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.shortcutKey);
  },
  methods: {
    onSeekTxt(txt) {
      this.seekTxt = txt;
    },
    onSeekTxt2(txt) {
      this.seekTxt2 = txt;
    },
    // 选中
    pitchOn(e, type) {
      var event = window.event || e;
      var target = event.srcElement ? event.srcElement : event.target;
      if (
        /input|textarea/i.test(target.tagName) &&
        /firefox/i.test(navigator.userAgent)
      ) {
        //Firefox在文本框内选择文字
        var staIndex = target.selectionStart;
        var endIndex = target.selectionEnd;
        if (staIndex != endIndex) {
          var sText = target.value.substring(staIndex, endIndex);
          this.tanchu(sText);
        }
      } else {
        //获取选中文字
        var sText =
          document.selection == undefined
            ? document.getSelection().toString()
            : document.selection.createRange().text;
        if (sText != "") {
          //将参数传入回调函数fn
          this.tanchu(sText);
        }
      }
    },
    // 选中文字
    tanchu(txt) {
      this.seekTxt = txt;
      if (this.isSeekBox === 1) {
        this.seekChange();
      }
    },
    seekShow() {
      //  this.seekChange()
      var that = this;
      // that.codeRigBox();
      if (that.isSeekBox === 1) {
        that.isSeekBox = false;
        console.log("999999999");

        let dom = document.getElementById("multipleTable");
        let seekActive = dom.getElementsByClassName("seekActive");
        if (!seekActive) {
          return
        }
        let len = seekActive.length;
        if (len > 0) {
          for (let i = len - 1; i > -1; i--) {
            if (i >= 0) {
              seekActive[i].style.background = "";
              seekActive[i].classList.remove("seekActive");
            }
          }
        }
        that.seekTxt = "";
        that.seekTxt2 = "";
      } else {
        that.isSeekBox = 1;
        that.seekChange();
      }
    },

    // 查找 下一个
    seekNext() {
      let domList = document.getElementsByClassName("seekActive");
      if (domList.length === 0 || domList.length === 1) {
        return;
      }
      if (this.seekIndex >= domList.length - 1) {
        domList[0].style.background = "rgb(163, 217, 241)";
        domList[this.seekIndex].style.background = "yellow";
        this.seekIndex = 0;
        domList[this.seekIndex].scrollIntoView();
        this.seekNum = 1;
        return;
      }

      this.seekIndex++;
      this.seekNum++;
      // console.log(this.seekIndex);
      domList[this.seekIndex].scrollIntoView();
      // let top = this.$refs.viewBox2.scrollTop;
      // this.$refs.viewBox2.scrollTo(0, num);
      if (this.seekIndex > 0) {
        domList[this.seekIndex].style.background = "rgb(163, 217, 241)";
        domList[this.seekIndex - 1].style.background = "yellow";
      } else {
        domList[this.seekIndex].style.background = "rgb(163, 217, 241)";
      }
    },
    // 查找 上一个
    previous() {
      let domList = document.getElementsByClassName("seekActive");
      let len = domList.length;
      if (len === 0 || len === 1) {
        return;
      }

      if (this.seekIndex === 0) {
        domList[len - 1].style.background = "rgb(163, 217, 241)";
        domList[0].style.background = "yellow";
        this.seekIndex = len - 1;
        domList[this.seekIndex].scrollIntoView();
        this.seekNum = len;
        return;
      }
      this.seekIndex--;
      this.seekNum--;
      domList[this.seekIndex].scrollIntoView();
      domList[this.seekIndex].style.background = "rgb(163, 217, 241)";
      domList[this.seekIndex + 1].style.background = "yellow";
    },
    // 查找
    seekChange() {
      let domList = document.getElementsByClassName("seekActive");
      let len = domList.length;
      if (len > 0) {
        for (let i = len - 1; i > -1; i--) {
          if (i >= 0) {
            domList[i].style.background = "";
            domList[i].classList.remove("seekActive");
          }
        }
      }
      this.seekNum2 = 0;
      this.seekNum = 0;
      this.seekIndex = 0;
      if (this.seekTxt === "") {
        return;
      }
      let oAt = document.getElementById('multipleTable');
      let dom = oAt.getElementsByClassName("edit");
      let seekTxt = this.seekTxt;
      if (seekTxt.indexOf(".") != -1 || seekTxt.indexOf("?") != -1) {
        let ary = seekTxt.split("")
        for (let i = 0; i < ary.length; i++) {
          if (ary[i] === "." || ary[i] === "?") {
            ary[i] = "\\" + ary[i]
          }
        }
        seekTxt = ary.join("")
      }
      let reg = new RegExp(seekTxt, "ig");
      dom = Array.from(dom);
      dom.forEach((item, index) => {
        let result = reg.exec(item.innerText);
        if (result) {
          let activeStr = item.innerText.replace(reg, function (params) {
            console.log(params);
            return (
              '<span class="seekActive" style="background:yellow;">' +
              params +
              "</span>"
            );
          });
          item.innerHTML = activeStr;
          this.$nextTick(() => {
            let domActList = document.getElementsByClassName("seekActive");
            this.seekNum2 = domActList.length;
            this.seekNum = 1;
            domActList[0].scrollIntoView();
            domActList[0].style.background = "rgb(163, 217, 241)";
          });
        }
      });

    },
    // 替换
    async onReplace() {
      let domList = document.getElementsByClassName("seekActive");
      if (domList.length < 1) {
        // 为空时不执行
        return;
      }
      let dom = domList[this.seekIndex].parentNode;
      let sonDom = domList[this.seekIndex];
      sonDom.style.background = "";
      sonDom.innerText = this.seekTxt2;
      sonDom.classList.remove("seekActive");
      let row;
      this.tableData.forEach((item) => {
        if (item.id == dom.getAttribute("sId")) {
          row = item
        }
      })
      let type = 0
      if (dom.getAttribute("type") === "target") {  // 目标句子
        type = 1
      }
      await this.changeUpdate(row, dom, type, true);
      this.$nextTick(() => {
        this.seekNum2 = domList.length;
        if (this.seekNum > this.seekNum2) {
          this.seekNum = this.seekNum2;
          this.seekIndex--;
          domList[this.seekIndex].style.background = "rgb(163, 217, 241)";
        } else {
          this.seekIndex ? domList[this.seekIndex].style.background = "rgb(163, 217, 241)" : '';
        }
        this.seekChange();
      });
      if (this.seekNum2 === 1) {
        this.seekNum = 0;
      }
    },
    // 全部替换
    async replaceChange() {
      // this.$nextTick(()=>{
      //   var viewBox = this.$refs.redactBox.innerHTML
      //  var p = viewBox.split(this.seekTxt).join("<span>"+this.seekTxt2+"</span>")
      //  viewBox = p;
      // })
      let that = this;
      var str2 = this.seekTxt;
      var str3 = this.seekTxt2;
      var oAt = document.getElementById('multipleTable');
      if (!str2) {
        // this.$message.closeAll();
        // this.$message({
        //   message: "请输入要替换的内容",
        //   type: "warning"
        // });
        return;
      }
      let dom = oAt.getElementsByClassName("edit");
      dom = Array.from(dom);
      let seekTxt = this.seekTxt;
      if (seekTxt.indexOf(".") != -1 || seekTxt.indexOf("?") != -1) {
        let ary = seekTxt.split("")
        for (let i = 0; i < ary.length; i++) {
          if (ary[i] === "." || ary[i] === "?") {
            ary[i] = "\\" + ary[i]
          }
        }
        seekTxt = ary.join("")
      }
      let reg = new RegExp(seekTxt, "ig");
      dom.forEach(item => {
        let text = item.innerHTML;
        let result = reg.exec(item.innerText);
        if (result) {
          if (str3 === "" && item.innerText === "") {
            // 阻止修改为空
            return;
          }
          let activeStr = item.innerText.replace(reg, function (params) {
            return (
              '<span class="seekActive" style="background:yellow;">' +
              str3 +
              "</span>"
            );
          });
          that.seekIndex = 0;
          item.innerHTML = activeStr;
          if (item.innerText === "") {
            item.innerHTML = text;
            this.$message.closeAll();
            this.$message({
              message: "内容不能为空",
              type: "warning"
            });
          }
        }
      });
      await this.$nextTick(() => {
        let seekDom = document.getElementsByClassName("seekActive");
        seekDom = Array.from(seekDom)
        for (let i = 0; i < seekDom.length; i++) {
          if (seekDom[i].parentNode.isContentEditable && seekDom[i].parentNode.getAttribute("type") === "target") {
            let row = this.tableData.filter(item => item.id == seekDom[i].parentNode.getAttribute("sId"))
            let type = 0
            if (seekDom[i].getAttribute("type") === "target") {  // 目标句子
              type = 1
            }
            this.changeUpdate(row[0], seekDom[i].parentNode, type, true);
          }
        }
        that.seekChange();
      });
    },
    // 快捷键
    shortcutKey(e) {
      let that = this;
      e = e || window.event;
      let k = e.keyCode || e.which;
      console.log(k, e, "?????");
      switch (k) {
        case 219:
          if (e.ctrlKey) {
            that.getMesBox()
            e.returnValue = false;
            e.preventDefault(e);
            return false;
          }
          break;
        case 71: // 
          if (e.ctrlKey && e.altKey) { // 拆分
            e.returnValue = false;
            that.onSplit();
            e.preventDefault(e);
            return false;
          } else if (e.ctrlKey) {  // 合并
            e.returnValue = false;
            that.onMerge()
            e.preventDefault(e);
            return false;
          }
          break;
        case 77: // 添加到记忆库
          if (e.ctrlKey) {
            e.returnValue = false;
            that.countBlankSent();
            e.preventDefault(e);
            return false;
          }
          break;
        case 221: // 删除
          if (e.ctrlKey) {
            that.toggleBox()
            e.preventDefault(e);
            e.returnValue = false;
            return false;
          }
          break;
        case 46: // 全部删除
          if (e.ctrlKey) {
            that.allDele()
            e.preventDefault(e);
            e.returnValue = false;
            return false;
          }
        case 70:
          if (e.ctrlKey) {
            // 查找替换
            e.returnValue = false;
            that.seekShow();
            e.preventDefault(e);
            return false;
          }
          break;
          break;
      }
    },
    onUndo() {
      document.execCommand("Undo");
      this.updateText = ""
    },
    onRedo() {
      document.execCommand("Redo");
      this.updateText = ""
    },
    // 合并
    async onMerge() {
      if (this.multipleSelection.length < 2) {
        this.$message.closeAll();
        this.$message({
          message: "请选择要合并的数据",
          type: "warning"
        });
        return;
      }
      if (this.upMerge) {
        this.$message.closeAll();
        this.$message({
          message: "合并的数据要连续哦!",
          type: "warning"
        });
        return;
      }

      const params = {
        idFrom: this.multipleSelection.slice(1),  // 被合并句子ID集合
        idTo: this.multipleSelection[0]// 合并到句子ID
      }
      const { result, resultCode } = await this.catReq1Service(
        "/api/v1/bilingual/mergeBilingualSent",
        params,
        "post"
      )
      if (resultCode === '1') {
        this.$message({
          message: "合并成功!",
          type: "success"
        })
        this.queryPage(this.currentPage, this.quetyData.groupId);
      }
    },
    // 拆分
    async onSplit() {
      if (!this.sentenceShow) {
        this.$message.closeAll();
        this.$message({
          message: "请将光标放在编辑区",
          type: "warning"
        });
        return;
      }

      if (!this.splitTargetSent) {
        this.$message.closeAll();
        this.$message({
          message: "请将光标放在位置",
          type: "warning"
        });
        return;
      }

      const params = {
        id: this.row.id,
        spiltIndex: this.splitSourceSent.length
      }
      const { result, resultCode } = await this.catReq1Service(
        "/api/v1/bilingual/spiltBilingualSent",
        params,
        "post"
      )
      if (resultCode === '1') {
        this.$message({
          message: "拆分成功!",
          type: "success"
        })
        this.queryPage(this.currentPage, this.quetyData.groupId);
      }
    },
    // 获取光标位置
    getCursortPosition(e, row) {
      this.row = row;
      this.sentenceShow = true;
      let pos = 0;
      pos = this.getDivPosition(e.target);
      this.splitSourceSent = e.target.innerText.slice(0, pos);
      this.splitTargetSent = e.target.innerText.slice(pos);
      console.log(this.splitSourceSent, this.splitTargetSent, "this.splitTargetSent");
    },
    //可编辑获取坐标
    getDivPosition(element) {
      let caretOffset = 0;
      let doc = element.ownerDocument || element.document;
      let win = doc.defaultView || doc.parentWindow;
      let sel;
      if (typeof win.getSelection != "undefined") {
        //谷歌、火狐
        sel = win.getSelection();
        if (sel.rangeCount > 0) {
          //选中的区域
          let range = win.getSelection().getRangeAt(0);
          let preCaretRange = range.cloneRange(); //克隆一个选中区域
          preCaretRange.selectNodeContents(element); //设置选中区域的节点内容为当前节点
          preCaretRange.setEnd(range.endContainer, range.endOffset); //重置选中区域的结束位置
          caretOffset = preCaretRange.toString().length;
        }
      } else if ((sel = doc.selection) && sel.type != "Control") {
        //IE
        let textRange = sel.createRange();
        let preCaretTextRange = doc.body.createTextRange();
        preCaretTextRange.moveToElementText(element);
        preCaretTextRange.setEndPoint("EndToEnd", textRange);
        caretOffset = preCaretTextRange.text.length;
      }
      return caretOffset;
    },
    // 拖动表格
    setSort() {
      const el = this.$refs.multipleTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0];
      if (document.body.style.zoom === "0.8") {  // 拖动和zoom有冲突
        el.style.zoom = "1.25"
      }
      this.sortable = Sortable.create(el, {
        ghostClass: 'sortable-ghost',
        setData: function (dataTransfer) {
          dataTransfer.setData('Text', '')
        },

        onEnd: evt => {
          const targetRow = this.tableData.splice(evt.oldIndex, 1)[0]
          this.tableData.splice(evt.newIndex, 0, targetRow)
          if (evt.newIndex !== evt.oldIndex) {
            let i = evt.newIndex;
            if (evt.newIndex >= evt.oldIndex) {
              i++
            }
            this.querySort(targetRow, i)
          }
        }
      })
    },
    // 排序接口
    async querySort(row, sort) {
      const params = {
        id: row.id,
        sort
      }
      const { result, resultCode } = await this.catReq1Service(
        "/api/v1/bilingual/moveBilingualSent",
        params,
        "post"
      )
      if (resultCode === '1') {
        this.$message({
          message: "排序成功!",
          type: "success"
        })
        this.queryPage(this.currentPage, this.quetyData.groupId);
      }
    },
    // 保存到记忆库
    async preserveMemory() {
      let _this = this
      this.$confirm('是否将本批对齐结果保存到记忆库，并跳转到记忆库列表？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.memoryApi()
      }).catch(() => {

      });
    },
    async memoryApi() {
      const resp = await this.catReq1Service('/api/v1/bilingual/addBatchSendMemory', { groupId: this.quetyData.groupId })
      if (resp.success) {
        //memoryBank
        this.$router.push({ name: "memoryBank" })
      }
    },
    // 是否有空的句子
    async countBlankSent() {
      const params = {
        groupId: this.quetyData.groupId,
      }
      const { result, resultCode } = await this.catReq1Service(
        "/api/v1/bilingual/countBlankSent",
        params,
        "post"
      )
      if (resultCode === '1') {
        if (result) {
          this.$confirm('本批对齐结果含有空白行，请确认是否保存到记忆库（空白行将会忽略）？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.memoryApi()
          })
        } else {
          this.preserveMemory()
        }

      }
    },
    // 全部删除
    allDele() {
      let _this = this
      this.$confirm('是否删除本批所有对齐结果，并返回双语对齐上传页面？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const resp = await _this.catReq1Service('/api/v1/bilingual/batchDeleteAll', { id: _this.quetyData.groupId })
        if (resp.success) {
          _this.$router.push({ name: "alignment" })
        }
      }).catch(() => {

      });

    },


    keyUp(event) {
      //确定
      if (event.keyCode === 13) {
        this.confirm();
      } else if (event.keyCode === 27) {
        this.call();
      }
      // this.$parent.del();
    },

    // 跳转页
    handleCurrentChange(val) {
      this.loading = true;
      this.queryPage(val, this.quetyData.groupId);
      sessionStorage.setItem("myCurrentPage", val); // 将页码存sessionStorage，刷新还在当前页
    },
    // 获取表格
    queryPage(page, id) {
      var that = this;
      if(that.isSeekBox){
        that.isSeekBox = 0;
        that.seekTxt = "";
        that.seekTxt2 = "";
      }
      that.loading = true;
      var params = {
        page,
        rows: "20",
        filter: {
          group_id: id,
        },
        sort: {
          create_time: "desc"
        }
      };
      this.catReq1Service('/api/v1/bilingual/queryPage', params).then(function (response) {
        if (!response.success) {
          return;
        }
        if (response.list == null) {
          response.list = [];
        }
        that.totalRows = response.totalRows;
        that.tableData = response.list;
        that.loading = false;
        if (that.currentPage > 1 && that.tableData.length < 1) {
          sessionStorage.myCurrentPage = sessionStorage.myCurrentPage - 1;
          that.currentPage - 1;
          that.queryPage(sessionStorage.myCurrentPage, that.quetyData.groupId);
        } else {
          that.$nextTick(() => {
            that.setSort()
          })
        }

      });
    },
    // 弹窗确定
    confirm() {
      var that = this;
      if (!that.isDel) {
        this.topText = this.topText.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");
        this.botText = this.botText.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");
        if (that.topText === "") {
          that.$message.closeAll();
          that.$message({
            message: "请填写原文",
            type: "warning"
          });
          return;
        }
        if (that.botText === "") {
          that.$message.closeAll();
          that.$message({
            message: "请填写译文",
            type: "warning"
          });
          return;
        }

        var params = {
          sourceSent: that.topText,
          targetSent: that.botText,
          batchId: that.quetyData.id,
        };
        this.catReq1Service("/api/v1/bilingual/addBilingualSent", params).then(function (response) {
          if (!response.success) {
            return;
          }
          that.isShow = false;
          that.topText = "";
          that.botText = "";
          sessionStorage.setItem("myCurrentPage", 1);
          that.currentPage = 1;
          that.queryPage(1, that.quetyData.groupId);
        });
      } else {
        that.toggleSelection(); //删除
      }
    },
    // 弹窗取消
    call() {
      var that = this;
      that.isShow = false;
      that.topText = "";
      that.botText = "";
    },
    // 添加弹窗
    getMesBox() {
      var that = this;
      that.isShow = true;
      that.isDel = false;
      that.downloadBoxTit = "添加句对"

    },
    // 添加弹窗关闭
    getMesShow() {
      this.isShow = false;
    },

    // 返回上一页
    backtrack() {
      this.$router.go(-1);
    },
    // 验证是否修改
    changeVerify(e) {
      this.beforeDate = e.target.innerHTML;
      this.updateText = e.target.innerText;
    },
    // 修改
    changeUpdate(row, target, type, contrast) {
      console.log("////??", contrast);
      let that = this
      setTimeout(() => {
        this.sentenceShow = false
      }, 500);
      let data = target.innerText.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");
      row.te = true;
      let reg = /(<span>)|(<\/span>)/g;
      let sourceSent = row.sourceSent
      let targetSent = row.targetSent
      if (!contrast && this.updateText.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "") === data) {
        return
      }

      if (this.repetition && data === this.repetition.data && row.id === this.repetition.id) {
        return
      }
      this.repetition = {
        id: row.id,
        data
      }

      var params = {
        id: row.id,
        [!type ? "sourceSent" : "targetSent"]: data,
        batchId: this.quetyData.id,
      };

      this.catReq1Service("/api/v1/bilingual/updateBilingualSent", params).then(function (response) {
        if (response.resultCode == 1) {
          that.$message.closeAll();
          that.$message({
            message: "修改成功!",
            type: "success"
          })
        } else {
          e.target.innerHTML = that.beforeDate
        }
      });

    },
    // 保存
    qwe(row) {
      // console.log(row);
    },
    // 删除弹窗
    toggleBox() {
      if (this.multipleSelection.length < 1) {
        this.$message.closeAll();
        this.$message({
          message: "请选择要删除的数据",
          type: "warning"
        });
        return;
      }
      var that = this;
      that.downloadBoxTit = "友情提示";
      that.isShow = true;
      that.isDel = true;
    },
    //  删除
    toggleSelection() {

      var that = this;
      var params = {
        id: this.quetyData.id,
        idList: this.multipleSelection,
      };
      this.catReq1Service("/api/v1/bilingual/batchDeleteByIdList", params).then(function (response) {
        if (!response.success) {
          return;
        }
        that.isShow = false;
        that.sentCount = that.sentCount - that.multipleSelection.length;
        that.queryPage(that.currentPage, that.quetyData.groupId);
      });
    },
    handleSelectionChange(val) {
      // 选中的元素
      // console.log(val, "/////////////");
      var arr = [];
      if (val.length > 1) {
        val.sort((a, b) => {
          return a.sort - b.sort
        })
      }
      this.upMerge = false;
      val.forEach((item, index) => {
        if (val[index + 1] && item.sort + 1 !== val[index + 1].sort) {
          this.upMerge = true
        }
        arr.push(item.id);
      });
      this.multipleSelection = arr;
    }
  }
};
</script>
<style>
.sortable-ghost {
  opacity: 0.6;
  color: #fff !important;
  background: #454545 !important;
}
</style>
<style lang="less" scoped>
.checkTab {
  position: relative;
  .seek {
  }
  .returnBtn {
    width: 48px;
    height: 30px;
    line-height: 30px;
    background: #02a4fd;
    color: #fff;
    font-size: 18px;
  }
  // 添加弹窗
  .hide {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 1);
    opacity: 0.7;
    z-index: 888;
  }
  .downloadBox {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(76, 76, 76, 0.8);
    border-radius: 10px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    opacity: 1;
    h5 {
      width: 100%;
      height: 48px;
      line-height: 48px;
      border-radius: 10px 10px 0px 0px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      position: relative;
      border-bottom: 1px solid #ece6e6;
      // background: url("../../assets/imgs/memory/popup_background.png");
      span {
        position: absolute;
        right: 10px;
        img {
          cursor: pointer;
          -webkit-transition: -webkit-transform 0.6s ease-out;
          -moz-transition: -moz-transform 0.6s ease-out;
          transition: transform 0.6s ease-out;
        }
        img:hover {
          -webkit-transform: rotate(180deg);
          -moz-transform: rotate(180deg);
          transform: rotate(180deg);
        }
      }
    }
    .mainText {
      margin: 50px 0px;
      font-size: 16px;
      width: 450px;
    }
    .main {
      margin: 50px 0;
      width: 826px;
      div {
        display: flex;
        justify-content: center;
        margin-bottom: 28px;
        .txt {
          resize: none;
          width: 643px;
          height: 130px;
          background: rgba(249, 249, 249, 1);
          border: 1px solid rgba(221, 221, 221, 1);
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(69, 69, 69, 1);
        }
        .txt:focus {
          outline: none;
          border: 1px solid #454545;
        }
        p {
          float: left;
          width: 50px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: rgba(69, 69, 69, 1);
        }
      }
    }
    .but {
      padding-bottom: 30px;
      margin: 0 80px;
      button:nth-child(2) {
        margin-left: 30px;
      }
    }
  }
  // 添加弹窗 结束
  header {
    display: flex;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
    margin-bottom: 15px;
    text-align: center;
    padding: 0 10px;
    position: relative;
    div {
      margin: 0 auto;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  main {
    height: 100%;
    textarea {
      vertical-align: middle;
      // text-align:center;
    }
    // width: 1660px;
    position: relative;
    // height: 783px;
    height: calc(100% - 45px);
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    // margin-top: 62px;
    padding: 0 20px;
    h3 {
      text-align: left;
      height: 20px;
      font-size: 18px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      padding-top: 20px;
      margin-left: 29px;
    }
    .topBox {
      margin-left: 29px;
      padding-top: 16px;
      margin-bottom: 7px;
      height: 40px;
      line-height: 38px;
      position: relative;
      input {
        float: right;
        width: 224px;
        height: 36px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(184, 196, 206, 1);
        border-radius: 2px 0px 0px 2px;
        padding: 0 10px;
        padding-right: 24px;
      }
      input:focus {
        outline: none;
        border: 1px solid #454545;
      }
      button {
        float: left;
        width: 80px;
        height: 32px;
        box-sizing: border-box;
        background: rgba(69, 69, 69, 1);
        box-shadow: 0px 2px 4px 0px rgba(153, 153, 153, 0.5);
        border-radius: 0px 2px 2px 0px;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        border: 0px;
        margin-right: 40px;
      }
      .topBox_btn_right {
        float: right;
        .el-button {
          line-height: 0;
          padding: 0;
        }
        .el-button:first-child {
          width: 110px;
          height: 32px;
          background: rgba(69, 69, 69, 1);
          border-radius: 4px;
        }
        .el-button:last-child {
          margin-left: 30px;
          width: 92px;
          height: 32px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          background: rgba(102, 102, 102, 1);
          border-radius: 4px;
        }
      }
      .topBox_btn_wrap {
        float: left;
        // margin-right: 20px;
        button {
          width: 70px;
          margin-left: 0px;
          margin-right: 0;
          font-size: 14px;
          background: rgba(69, 69, 69, 1);
          box-shadow: none;
          margin-right: 10px;
          border-radius: 4px;
        }
      }
    }
    #notDate {
      // 暂无数据
      // margin-top: 80px;
      height: 100%;
      img {
        height: 50%;
        width: 50%;
      }
    }
    /deep/.el-table--border::after,
    .el-table--group::after {
      width: 0px;
    }
    // /deep/.el-table::before {
    //   background-color: transparent;
    // }
    /deep/.has-gutter {
      tr {
        th {
          border: 0px;
          border-bottom: 1px solid #ebeef5;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: center;
        }
      }
    }
    /deep/.el-table td,
    .el-table th {
      // 修改table行高
      padding: 0px !important;
      // height: 46px;
    }
    .el-table td,
    .el-table th {
      padding: 0px;
    }
    /deep/.el-table td:nth-child(1) {
      border-left: 1px solid #ebeef5;
    }
    /deep/.el-table td {
      text-align: center;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
    }
    /deep/.el-table td:nth-child(2) {
      cursor: all-scroll;
    }
    /deep/.el-table td:nth-child(3) {
      text-align: left;
    }
    /deep/.el-table td:nth-child(4) {
      text-align: left;
    }
    /deep/.el-table--enable-row-hover .el-table__body tr tr tr:hover {
      box-shadow: 0px 1px 6px 0px rgba(102, 102, 102, 0.5);
    }
    /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
      // table 鼠标滑动效果
      background: #f5f7fa;
    }
    /deep/.el-table::before {
      display: none;
    }
    /deep/.el-table {
      border: 0px;
      //   width: 1620px;
      .cell {
        display: flex;
        justify-content: center;
        align-items: center;
        div {
          min-height: 36px;
          width: 650px;
          border: 0px;
          padding: 5px;
          // resize: none;
          background: transparent;
        }
        div:focus {
          //清除div获取焦点之后出现的边框
          outline: none;
        }
      }

      button {
        width: 60px;
        height: 28px;
        line-height: 28px;
        background: rgba(241, 241, 241, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        border-radius: 4px;
        border: 0px;
        color: rgba(153, 153, 153, 1);
      }
      .butClass {
        background: rgba(57, 139, 241, 1);
        color: rgba(255, 255, 255, 1);
        border: 0px;
      }
    }

    /* 页码样式开始 */
    /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
      // 页码点击效果
      // background: rgba(69, 69, 69, 1);
      color: rgba(255, 255, 255, 1);
      border: 0px;
    }
    /deep/.el-pager li {
      // 页码样式
      min-width: 30px;
      height: 30px;
      border: 1px solid rgba(187, 187, 187, 1);
      border-radius: 2px;
      background: transparent;
      line-height: 30px;
      font-size: 14px;
      font-weight: 400;
    }
    /deep/.el-pagination button {
      // 页码上下页样式
      width: 68px;
      height: 30px;
      border: 1px solid rgba(187, 187, 187, 1);
      border-radius: 2px;
      line-height: 30px;
      font-size: 14px;
      background: transparent;
      color: rgba(102, 102, 102, 1);
      font-weight: 400;
    }
    /deep/.el-pagination button:hover {
      border: 1px solid rgba(128, 128, 128, 1);
    }
    /deep/.el-pagination button:active {
      background: rgba(224, 237, 252, 1);
      border: 1px solid rgba(187, 187, 187, 1);
    }
    .page {
      position: absolute;
      bottom: 20px;
      right: 20px;
    }
    /* 页码样式结束 */
  }
  /deep/.el-table__row {
    td {
      .cell {
        white-space: pre-wrap;
        word-wrap: break-word;
        word-break: normal;
        word-break: break-all;
      }
    }
  }
}
</style>
<style lang="less">
.checkTab {
  main {
    //  height:calc(100% - 52px);
    .el-table {
      // 高亮显示当前行的样式
      .el-table__body tr.current-row > td {
        // border-right: 1px solid #666666;
        border-bottom: 1px solid #666666;
        border-top: 1px solid #666666;
        // border: 1px solid #666666;
        background-color: #f5f7fa;
        // color: #fff;
      }
      .el-table__body tr.current-row > td:first-child {
        border-left: 1px solid #666666 !important;
      }
      height: calc(100% - 50px);
      .el-table__body-wrapper {
        overflow-y: auto;
        height: calc(100% - 48px);
      }
    }
  }
}
</style>